import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/workspace/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/components/InclusivelyHidden/InclusivelyHidden.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectsBlock"] */ "/workspace/src/components/ProjectsBlock/ProjectsBlock.tsx");
